import { HeartBank } from "../../../managers/HeartBank.ts";
import template from "./hb-map.mjs";
import { render } from "lit-html";
import { Chests } from "../../../models/Chests.ts";
import { Chest } from "../../../managers/Chest.ts";
import { Kiitti } from "../../../models/Kiitti.ts";
import { User } from "firebase/auth";
import { getDeviceID } from "../../global.ts";

export class HbMap extends HTMLElement {
    private heartbank = new HeartBank();
    private chests = new Chests();
    private moments = new Kiitti();
    private did = getDeviceID();
    private map: HTMLElement;

    constructor() {
        super();
        render(template(null), this);

        this.map = this.querySelector("#hb-map")!;
    }

    connectedCallback() {
        const observer = new MutationObserver(() => {
            const isDark = document.documentElement.classList.contains("dark");
            window.earth.renderMap(this.map, isDark ? "dark" : "light");
        });
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ["class"]
        });

        this.heartbank.addAuthStateListener((user) => {
            if (window.earth.map) this.render(user);
        });
    }

    async render(user: User | null = null) {
        if (!window.earth.map) {
            window.earth.map = await window.earth.renderMap(this.map);
            const bounds = new google.maps.LatLngBounds();

            if (window.earth.marker?.position)
                bounds.extend(window.earth.marker.position);

            await this.renderMoments(bounds, user);
            //await this.renderMints(bounds, user);
            //await this.renderMines(bounds, user);

            if (!bounds.isEmpty()) {
                window.earth.map.fitBounds(bounds);
                window.earth.map.panToBounds(bounds, 50);
            }
        }
    }

    async renderMoments(
        bounds: google.maps.LatLngBounds,
        user: User | null = null
    ) {
        window.earth.mintMarkers.forEach((marker) => {
            marker.map = null;
        });
        window.earth.mintMarkers = [];

        const moments = await this.moments.getAll(user?.uid || "");
        for (const moment of moments) {
            const pin = new google.maps.marker.PinElement({
                background: "purple",
                borderColor: "violet",
                glyph: "💜", //❤
                glyphColor: "white",
                scale: 1.5
            });

            const position: google.maps.LatLngLiteral = {
                lat: moment.lat,
                lng: moment.lng
            };
            const marker = new google.maps.marker.AdvancedMarkerElement({
                position,
                map: window.earth.map,
                content: pin.element,
                title: moment.place
            });

            marker.addListener("gmp-click", () => {
                const event = new CustomEvent("hb-treasury", {
                    detail: {
                        isShow: false
                    },
                    bubbles: true,
                    composed: true
                });
                this.dispatchEvent(event);
                window.location.hash = `#/aquarius/${moment.id}`;
            });
            window.earth.mintMarkers.push(marker);
            bounds.extend(position);
        }
    }

    async renderMints(
        bounds: google.maps.LatLngBounds,
        user: User | null = null
    ) {
        window.earth.mintMarkers.forEach((marker) => {
            marker.map = null;
        });
        window.earth.mintMarkers = [];

        const mints = await this.chests.getMints(user?.uid || "");
        for (const mint of mints) {
            const data = JSON.parse(
                decodeURIComponent(mint.data.split("/")[1])
            );
            const chest = new Chest(mint, data);

            const pin = new google.maps.marker.PinElement({
                background: "silver",
                borderColor: "gray",
                glyph: "🩶",
                glyphColor: "white",
                scale: 1.5
            });

            const position: google.maps.LatLngLiteral =
                await chest.getLocation();

            const marker = new google.maps.marker.AdvancedMarkerElement({
                position,
                map: window.earth.map,
                content: pin.element,
                title: mint.name
            });

            marker.addListener("gmp-click", () => {
                const event = new CustomEvent("hb-treasury", {
                    detail: {
                        isShow: false
                    },
                    bubbles: true,
                    composed: true
                });
                this.dispatchEvent(event);
                window.location.hash = `#/chest/${mint.id}`;
            });
            window.earth.mintMarkers.push(marker);
            bounds.extend(position);
        }
    }

    async renderMines(
        bounds: google.maps.LatLngBounds,
        user: User | null = null
    ) {
        window.earth.mineMarkers.forEach((marker) => {
            marker.map = null;
        });
        window.earth.mineMarkers = [];

        const mines = await this.chests.getMines(this.did, user?.uid || "");
        for (const mine of mines) {
            const data = JSON.parse(
                decodeURIComponent(mine.data.split("/")[1])
            );
            const chest = new Chest(mine, data);

            const pin = new google.maps.marker.PinElement({
                background: "gold",
                borderColor: "orange",
                glyph: "💛",
                glyphColor: "white",
                scale: 1.0
            });

            const position: google.maps.LatLngLiteral =
                await chest.getLocation();

            const marker = new google.maps.marker.AdvancedMarkerElement({
                position,
                map: window.earth.map,
                content: pin.element,
                title: mine.name
            });

            marker.addListener("gmp-click", () => {
                const event = new CustomEvent("hb-treasury", {
                    detail: {
                        isShow: false
                    },
                    bubbles: true,
                    composed: true
                });
                this.dispatchEvent(event);
                window.location.hash = `#/chest/${mine.id}`;
            });
            window.earth.mineMarkers.push(marker);
            bounds.extend(position);
        }
    }
}
